"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommentCell = void 0;
var comment_cell_component_1 = require("./comment-cell.component");
Object.defineProperty(exports, "CommentCell", { enumerable: true, get: function () { return comment_cell_component_1.CommentCell; } });
